module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_1@2x.9ced8685.png";